var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('CCol',{ref:"content",attrs:{"xs":"12","lg":"12"}},[_c('CCard',[_c('CCardBody',[_c('v-card',{staticStyle:{"padding-top":"20px","padding-left":"20px","padding-right":"20px","padding-bottom":"30px"},attrs:{"shaped":""}},[_c('edit-profile-form')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }